import Resize from '../../directives/resize.js'
import Ripple from '../../directives/ripple.js'
import Tooltip from '../../directives/tooltip.js'
import AspectRatio from '../../directives/aspect-ratio.js'
import GradientText from '../../directives/gradient-text.js'
import Intersect from '../../directives/intersect.js'
import Store from '../../utils/store'
import { v4 as uuidv4 } from 'uuid'

Ripple.color = 'rgba(255, 255, 255, 0.25)'
Ripple.zIndex = 55

const BcUi = {
  install (Vue, opts = {}) {
    if (this.installed) {
      return
    }
    this.installed = true
    const $bcui = {}
    Vue.util.defineReactive($bcui, 'inspire', {})
    Vue.prototype.$bcui = $bcui.inspire
    Vue.prototype.$uuidv4 = uuidv4
    Vue.prototype.$store = Store
    Vue.util.defineReactive(Vue.prototype, '$dark', false)
    Vue.directive('resize', Resize)
    Vue.directive('ripple', Ripple)
    Vue.directive('tooltip', Tooltip)
    Vue.directive('aspect-ratio', AspectRatio)
    Vue.directive('gradient-text', GradientText)
    Vue.directive('intersect', Intersect)
    if (opts.transitions) {
      Object.keys(opts.transitions).forEach(key => {
        const t = opts.transitions[key]
        if (t.name !== undefined && t.name.startsWith('bcq-')) {
          Vue.component(t.name, t)
        }
      })
    }

    if (opts.directives) {
      Object.keys(opts.directives).forEach(key => {
        const d = opts.directives[key]
        Vue.directive(d.name, d)
      })
    }

    if (opts.components) {
      Object.keys(opts.components).forEach(key => {
        const c = opts.components[key]
        Vue.use(c)
      })
    }
  }
}

export default BcUi



// WEBPACK FOOTER //
// ./src/bcq-ui/components/bcq-ui/index.js